(function() {
  'use strict';

  if (window.__cpBackToSchoolBundleLoaded) {
    if (window.cpBackToSchoolBundleInit) {
      window.cpBackToSchoolBundleInit(document);
    }
    return;
  }

  window.__cpBackToSchoolBundleLoaded = true;

  var ACTIVE_CLASS = 'is-active';
  var BODY_LOCK_CLASS = 'cp-bts-bundle-modal-open';

  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  }

  function getRootUrl() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }
    if (window.T4Sroutes && window.T4Sroutes.root_url) {
      return window.T4Sroutes.root_url;
    }
    return '/';
  }

  function formatMoney(cents, moneyFormat) {
    if (window.T4SThemeSP && window.T4SThemeSP.Currency && typeof window.T4SThemeSP.Currency.formatMoney === 'function') {
      return window.T4SThemeSP.Currency.formatMoney(cents, moneyFormat);
    }

    var amount = Number(cents || 0) / 100;
    var formatted = amount.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });

    return (moneyFormat || '${{amount}}').replace(/\{\{\s*amount\s*\}\}/, formatted);
  }

  function normalizeQuantity(value) {
    var parsed = parseInt(value, 10);
    if (!parsed || parsed < 1) return 1;
    return Math.min(parsed, 99);
  }

  function normalizeImageUrl(url) {
    return String(url || '')
      .replace(/([?&])width=\d+&?/, '$1')
      .replace(/[?&]$/, '');
  }

  function getFocusable(container) {
    return Array.prototype.slice.call(container.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )).filter(function(element) {
      return !!(element.offsetWidth || element.offsetHeight || element.getClientRects().length);
    });
  }

  function shouldRestoreTriggerFocus() {
    return !window.matchMedia || window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  }

  function restoreTriggerFocus(trigger) {
    if (!trigger) return;

    if (!shouldRestoreTriggerFocus()) {
      if (typeof trigger.blur === 'function') {
        trigger.blur();
      }
      return;
    }

    if (typeof trigger.focus !== 'function') return;

    try {
      trigger.focus({ preventScroll: true });
    } catch (error) {
      trigger.focus();
    }
  }

  function openCartDrawer() {
    if (window.theme && window.theme.cart && typeof window.theme.cart.refresh === 'function') {
      try { window.theme.cart.refresh(); } catch (error) {}
    }

    document.dispatchEvent(new CustomEvent('cart:refresh'));
    window.dispatchEvent(new CustomEvent('cart:updated'));

    if (window.jQuery) {
      window.jQuery(document).trigger('cart.requestComplete');
    }

    window.setTimeout(function() {
      var drawer = document.querySelector('#t4s-mini_cart, [data-drawer-cart], .drawer--cart, #CartDrawer, .cart-drawer');

      if (drawer && window.T4SThemeSP && window.T4SThemeSP.Drawer && typeof window.T4SThemeSP.Drawer.opend === 'function' && window.jQuery) {
        try {
          window.T4SThemeSP.Drawer.opend(window.jQuery(drawer));
          return;
        } catch (error) {}
      }

      if (drawer) {
        drawer.classList.add('is-open', 'active', 'drawer--is-open');
        drawer.classList.remove('is-hidden', 'hidden');
        drawer.setAttribute('aria-hidden', 'false');
      }

      var drawerToggle = document.querySelector('[data-drawer-options*="#t4s-mini_cart"], [data-drawer-options*="t4s-mini_cart"], .header__cart-toggle, [data-cart-toggle], .cart-link, a[href="/cart"]');
      if (!drawerToggle) return;

      if (window.jQuery) {
        window.jQuery(drawerToggle).trigger('click.drawer');
      } else {
        drawerToggle.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
      }
    }, 100);
  }

  function BundleModal(modal) {
    this.modal = modal;
    this.panel = modal.querySelector('.cp-bts-bundle-modal__panel');
    this.form = modal.querySelector('[data-cp-bts-form]');
    this.productJson = modal.querySelector('[data-cp-bts-product-json]');
    this.variantInput = modal.querySelector('[data-cp-bts-variant-id]');
    this.price = modal.querySelector('[data-cp-bts-price]');
    this.compare = modal.querySelector('[data-cp-bts-compare]');
    this.image = modal.querySelector('[data-cp-bts-modal-image]');
    this.galleryTrack = modal.querySelector('[data-cp-bts-gallery-track]');
    this.gallerySlides = Array.prototype.slice.call(modal.querySelectorAll('[data-cp-bts-gallery-slide]'));
    this.galleryIndex = 0;
    this.quantityInput = modal.querySelector('[data-cp-bts-qty-input]');
    this.addButton = modal.querySelector('[data-cp-bts-add]');
    this.addLabel = modal.querySelector('[data-cp-bts-add-label]');
    this.message = modal.querySelector('[data-cp-bts-message]');
    this.lastTrigger = null;

    try {
      this.data = JSON.parse((this.productJson && this.productJson.textContent) || '{}');
    } catch (error) {
      this.data = {};
    }

    this.product = this.data.product || {};
    this.moneyFormat = this.data.moneyFormat || '${{amount}}';
    this.variants = this.product.variants || [];
    this.options = this.product.options || [];
    this.selectedOptions = this.getInitialOptions();
    this.bind();
    this.render();
  }

  BundleModal.prototype.getInitialOptions = function() {
    var variantId = parseInt((this.variantInput && this.variantInput.value) || 0, 10);
    var variant = this.variants.find(function(item) {
      return Number(item.id) === variantId;
    }) || this.variants.find(function(item) {
      return item.available;
    }) || this.variants[0];

    return variant && variant.options ? variant.options.slice() : [];
  };

  BundleModal.prototype.bind = function() {
    var modal = this;

    this.modal.addEventListener('click', function(event) {
      if (event.target.closest('[data-cp-bts-modal-close]')) {
        event.preventDefault();
        modal.close();
        return;
      }

      var valueButton = event.target.closest('[data-cp-bts-option-value]');
      if (valueButton) {
        event.preventDefault();
        if (valueButton.disabled) return;
        modal.selectOption(parseInt(valueButton.getAttribute('data-option-index'), 10), valueButton.getAttribute('data-value'));
      }

      if (event.target.closest('[data-cp-bts-gallery-prev]')) {
        event.preventDefault();
        modal.slideGalleryTo(modal.galleryIndex - 1);
      }

      if (event.target.closest('[data-cp-bts-gallery-next]')) {
        event.preventDefault();
        modal.slideGalleryTo(modal.galleryIndex + 1);
      }

      if (event.target.closest('[data-cp-bts-qty-minus]')) {
        event.preventDefault();
        if (!modal.quantityInput) return;
        modal.quantityInput.value = normalizeQuantity(modal.quantityInput.value) - 1;
        modal.quantityInput.value = normalizeQuantity(modal.quantityInput.value);
      }

      if (event.target.closest('[data-cp-bts-qty-plus]')) {
        event.preventDefault();
        if (!modal.quantityInput) return;
        modal.quantityInput.value = normalizeQuantity(modal.quantityInput.value) + 1;
        modal.quantityInput.value = normalizeQuantity(modal.quantityInput.value);
      }
    });

    this.modal.addEventListener('change', function(event) {
      var select = event.target.closest('[data-cp-bts-option-select]');
      if (!select) return;

      modal.selectOption(parseInt(select.getAttribute('data-option-index'), 10), select.value);
    });

    if (this.quantityInput) {
      this.quantityInput.addEventListener('change', function() {
        modal.quantityInput.value = normalizeQuantity(modal.quantityInput.value);
      });
    }

    if (this.form) {
      this.form.addEventListener('submit', function(event) {
        event.preventDefault();
        modal.addToCart();
      });
    }
  };

  BundleModal.prototype.open = function(trigger) {
    this.lastTrigger = trigger || document.activeElement;
    this.modal.classList.add(ACTIVE_CLASS);
    this.modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add(BODY_LOCK_CLASS);

    var focusables = getFocusable(this.modal);
    window.setTimeout(function() {
      (focusables[0] || this.panel || this.modal).focus();
    }.bind(this), 30);
  };

  BundleModal.prototype.close = function() {
    this.modal.classList.remove(ACTIVE_CLASS);
    this.modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove(BODY_LOCK_CLASS);
    restoreTriggerFocus(this.lastTrigger);
  };

  BundleModal.prototype.findVariant = function(options) {
    return this.variants.find(function(variant) {
      return variant.options && variant.options.every(function(value, index) {
        return value === options[index];
      });
    });
  };

  BundleModal.prototype.slideGalleryTo = function(index) {
    if (!this.galleryTrack || !this.gallerySlides.length) return;

    var total = this.gallerySlides.length;
    var nextIndex = ((Number(index) || 0) % total + total) % total;
    this.galleryIndex = nextIndex;
    this.galleryTrack.style.transform = 'translate3d(' + (-100 * nextIndex) + '%, 0, 0)';

    this.gallerySlides.forEach(function(slide, slideIndex) {
      slide.classList.toggle('is-active', slideIndex === nextIndex);
    });

  };

  BundleModal.prototype.syncGalleryToImage = function(imageUrl) {
    if (!imageUrl || !this.gallerySlides.length) return;

    var targetUrl = normalizeImageUrl(imageUrl);
    var index = this.gallerySlides.findIndex(function(slide) {
      return normalizeImageUrl(slide.getAttribute('data-image-src')) === targetUrl;
    });

    if (index >= 0) {
      this.slideGalleryTo(index);
    }
  };

  BundleModal.prototype.hasAvailableValue = function(optionIndex, value) {
    var selectedOptions = this.selectedOptions;

    return this.variants.some(function(variant) {
      if (!variant.available || !variant.options || variant.options[optionIndex] !== value) return false;

      return variant.options.every(function(optionValue, index) {
        return index === optionIndex || optionValue === selectedOptions[index];
      });
    });
  };

  BundleModal.prototype.selectOption = function(optionIndex, value) {
    this.selectedOptions[optionIndex] = value;

    var variant = this.findVariant(this.selectedOptions);
    if (!variant) {
      variant = this.variants.find(function(item) {
        return item.available && item.options && item.options[optionIndex] === value;
      }) || this.variants[0];

      if (variant && variant.options) {
        this.selectedOptions = variant.options.slice();
      }
    }

    this.render();
  };

  BundleModal.prototype.render = function() {
    var modal = this;
    var variant = this.findVariant(this.selectedOptions) || this.variants[0];

    this.modal.querySelectorAll('[data-cp-bts-option]').forEach(function(optionGroup) {
      var optionIndex = parseInt(optionGroup.getAttribute('data-option-index'), 10);
      var current = optionGroup.querySelector('[data-cp-bts-current-value]');
      if (current) current.textContent = modal.selectedOptions[optionIndex] || '';

      var select = optionGroup.querySelector('[data-cp-bts-option-select]');
      if (select) {
        select.value = modal.selectedOptions[optionIndex] || '';
        Array.prototype.slice.call(select.options).forEach(function(option) {
          var available = modal.hasAvailableValue(optionIndex, option.value);
          option.disabled = !available && option.value !== modal.selectedOptions[optionIndex];
        });
      }

      optionGroup.querySelectorAll('[data-cp-bts-option-value]').forEach(function(button) {
        var value = button.getAttribute('data-value');
        var selected = value === modal.selectedOptions[optionIndex];
        var available = modal.hasAvailableValue(optionIndex, value);

        button.classList.toggle('is-selected', selected);
        button.classList.toggle('is-unavailable', !available);
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
        button.disabled = !available && !selected;
      });
    });

    if (!variant) return;

    if (this.variantInput) this.variantInput.value = variant.id;
    if (this.price) this.price.innerHTML = formatMoney(variant.price, this.moneyFormat);

    if (this.compare) {
      if (variant.compareAtPrice && variant.compareAtPrice > variant.price) {
        this.compare.innerHTML = formatMoney(variant.compareAtPrice, this.moneyFormat);
        this.compare.classList.remove('is-hidden');
      } else {
        this.compare.innerHTML = '';
        this.compare.classList.add('is-hidden');
      }
    }

    if (this.image && variant.image) {
      this.image.src = variant.image;
    } else if (this.image && this.product.featuredImage) {
      this.image.src = this.product.featuredImage;
    }

    this.syncGalleryToImage(variant.image || this.product.featuredImage);

    if (this.addButton && this.addLabel) {
      this.addButton.disabled = !variant.available;
      this.addLabel.textContent = variant.available ? (this.addButton.getAttribute('data-default-label') || 'Add to cart') : 'Sold out';
    }

    if (this.message) {
      this.message.textContent = variant.available ? '' : 'This bundle setup is currently sold out.';
    }
  };

  BundleModal.prototype.addToCart = async function() {
    var variant = this.findVariant(this.selectedOptions);
    if (!variant || !variant.available || !this.addButton) return;

    var quantity = normalizeQuantity(this.quantityInput ? this.quantityInput.value : 1);
    var defaultLabel = this.addButton.getAttribute('data-default-label') || 'Add to cart';

    this.addButton.disabled = true;
    this.addButton.classList.add('is-loading');
    this.addLabel.textContent = 'Adding...';
    if (this.message) this.message.textContent = '';

    try {
      var rootUrl = getRootUrl();
      if (rootUrl.slice(-1) !== '/') rootUrl += '/';

      var response = await fetch(rootUrl + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        credentials: 'same-origin',
        body: JSON.stringify({ id: Number(variant.id), quantity: quantity })
      });

      var payload = await response.json().catch(function() { return {}; });
      if (!response.ok || payload.status) {
        throw new Error(payload.description || 'Cart add failed');
      }

      this.addLabel.textContent = 'Added';
      if (this.message) this.message.textContent = '';

      document.dispatchEvent(new CustomEvent('cart:item-added', {
        detail: { variant_id: Number(variant.id), quantity: quantity }
      }));

      window.setTimeout(function() {
        this.close();
        openCartDrawer();
      }.bind(this), 350);
    } catch (error) {
      this.addLabel.textContent = 'Try again';
      if (this.message) this.message.textContent = 'Something went wrong. Please try again.';
    } finally {
      window.setTimeout(function() {
        this.addButton.classList.remove('is-loading');
        this.addButton.disabled = !variant.available;
        this.addLabel.textContent = variant.available ? defaultLabel : 'Sold out';
      }.bind(this), 1400);
    }
  };

  function initModals(scope) {
    (scope || document).querySelectorAll('[data-cp-bts-bundle-modal]:not([data-cp-bts-initialized])').forEach(function(modal) {
      modal.setAttribute('data-cp-bts-initialized', 'true');
      modal.cpBackToSchoolBundle = new BundleModal(modal);
    });
  }

  window.cpBackToSchoolBundleInit = initModals;

  document.addEventListener('click', function(event) {
    var trigger = event.target.closest('[data-cp-bts-modal-open]');
    if (!trigger) return;

    var selector = trigger.getAttribute('data-cp-bts-modal-open');
    var modal = selector ? document.querySelector(selector) : null;
    if (!modal) return;

    event.preventDefault();
    if (!modal.cpBackToSchoolBundle) {
      initModals(document);
    }
    if (modal.cpBackToSchoolBundle) {
      modal.cpBackToSchoolBundle.open(trigger);
    }
  });

  document.addEventListener('keydown', function(event) {
    var modal = document.querySelector('[data-cp-bts-bundle-modal].' + ACTIVE_CLASS);
    if (!modal || !modal.cpBackToSchoolBundle) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      modal.cpBackToSchoolBundle.close();
      return;
    }

    if (event.key !== 'Tab') return;

    var focusables = getFocusable(modal);
    if (!focusables.length) return;

    var first = focusables[0];
    var last = focusables[focusables.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  document.addEventListener('shopify:section:load', function(event) {
    initModals(event.target);
  });

  ready(function() {
    initModals(document);
  });
})();
